module.exports = __webpack_public_path__ + "img/image_020.034e8229.jpeg";